module.exports = __webpack_public_path__ + "static/img/banner.6f2f5d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_7/banner.jpg
// module id = PLYe
// module chunks = 0